import React from 'react'


import {API_BASE_URL} from '../../constants'
import axios from 'axios'

import ReactTable  from "react-table";
import {getToken} from '../../storage'


export default class BrandList extends React.Component {


  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateBrand = this.goToCreateBrand.bind(this)
    document.title = "Brand List"
  }

  goToCreateBrand(e) {
    e.preventDefault()
    this.props.history.push("/brands/create/")
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/brands/edit/'+row.original.id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }



    fetchData(state, instance) {
      this.setState({ loading: true });
      let apiurl = "/list_brands/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.brands,
          pages: res.data.pages,
          loading: false
        });
      });
    }


    render() {

      const { data, pages, loading } = this.state;
      const columns = [

        {Header:'Name', accessor: 'name',sortable:true },
        {Header: 'Code', accessor: 'code', sortable:true}

      ]
      const defaultSort=[{id: "name", desc: true}]
      return <div><section className="medium">
        <ul className="list-inline">
          <li><button onClick={this.goToCreateBrand} className="btn btn-primary">Create New Brand</button></li>
        </ul>
      </section>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Brands Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/brand/brandlist.js